/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

const Yes = () => <i className="bra-icn bra-icn__yes" data-class=" bra-icn__yes" />;

const CompareTableItem = ({ isFirstProduct, title, feature }) => {
  const isYes = feature === 'true';
  const isFalse = !feature || feature === 'false';
  return (
    <td className='bra-comparsionTable__cell'>
      {isFirstProduct ? (
        <h3 className='bra-comparsionTable__mobileTitle'>{title}</h3>
      ) : null}
      <p className='bra-comparsionTable__data bra-comparsionTable__cellContent'>
        {isYes && <Yes/>}
        {isFalse && '-'}
        {!isYes && !isFalse && feature}
      </p>
    </td>
  );
};

CompareTableItem.propTypes = {
  isFirstProduct: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  feature: PropTypes.string.isRequired,
};

export default CompareTableItem;
